/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import '../../Style/Table4.css'
import MaterialTable from 'material-table'
import AddIcon from '@material-ui/icons/Add'
import { Button, Grid } from '@material-ui/core'
import { getAdaptationMeasuresByForm } from '../../../../../services/Elegibilidad/get'
import { Modal52 } from '../../Modals/ModalSec5/Modal52'
import { Modal52Edit } from '../../Modals/ModalSec5Edit/Modal52Edit'
import { deleteAdaptationMeasures } from '../../../../../services/Elegibilidad/delete'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import { useEligibility } from '../../../../../context/EligibilityContext'
import NumberFormat from 'react-number-format'
import { updateAdaptationMeasures } from '../../../../../services/Elegibilidad/put'
import swal from 'sweetalert'

const Table52 = ({ idElegibilityForm, formik }) => {
  const [state, dispatch] = useEligibility()
  const [tableData, setTableData] = useState([])
  const [open, setOpen] = useState(false)
  const [openEdit, setOpenEdit] = useState(false)
  const [body, setBody] = useState({})
  const [addOther, setAddOher] = useState(true)
  const [isEditable, setIsEditable] = useState(true)
  const [disabled, setDisabled] = useState(false)

  const getDataTable = async () => {
    try {
      const response = await getAdaptationMeasuresByForm(idElegibilityForm)

      if (response.Success) {
        setTableData(response.Data)
        const result = response.Data.filter((obj) => obj.IdTechnology === 1)

        if (result.length === 0) setAddOher(true)
        else {
          setAddOher(false)
        }

        const resultValidate = response.Data.filter(
          (obj) => obj.IsImplemented === true,
        )
        if (resultValidate.length >= 1) {
          formik.setFieldValue('validTable52', true)
          setIsEditable(false)
          setDisabled(true)
        } else {
          formik.setFieldValue('validTable52', false)
          setIsEditable(true)
          setDisabled(false)
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    if (
      state.step === 5 &&
      idElegibilityForm !== undefined &&
      idElegibilityForm !== null &&
      tableData.length === 0
    ) {
      getDataTable()
    }
  }, [state.step])

  const handleDelete = async (oldData) => {
    const { IdAdaptationMeasure, IdElegibilityAnswer, IdTechnology } = oldData
    try {
      if (oldData.IdTechnology === 1) {
        await deleteAdaptationMeasures(IdAdaptationMeasure)
        getDataTable()
      } else {
        const body = {
          IdAdaptationMeasure: IdAdaptationMeasure,
          IdElegibilityAnswer: IdElegibilityAnswer,
          IdTechnology: IdTechnology,
          IsImplemented: false,
          Justification: null,
          IsRequired: false,
          LandAreaToImprove: null,
          agriculturistNumber: null,
          isDefault: true,
        }
        const response = await updateAdaptationMeasures(body)
        if (response.Success) {
          swal({
            title: '¡Datos eliminados exitosamente!',
            icon: 'success',
          })
          getDataTable()
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const columns = [
    {
      title: 'Tecnología de adaptación',
      field: 'TechnologyDetail',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
    },
    {
      title: 'Si',
      field: 'IsImplemented',
      filterPlaceholder: 'filter',
      type: 'boolean',
    },
    {
      title: 'Justificación',
      field: 'Justification',
      align: 'center',
      grouping: false,
    },
    {
      title: 'Requerido como parte del subproyecto',
      field: 'IsRequired',
      align: 'center',
      grouping: false,
      type: 'boolean',
    },
    {
      title: 'Área de tierra a mejorar con medida de adaptación (Ha)',
      field: 'LandAreaToImprove',
      align: 'center',
      grouping: false,
      render: (expense) =>
        expense.LandAreaToImprove !== null ? (
          <NumberFormat
            value={expense.LandAreaToImprove}
            thousandSeparator={true}
            decimalScale={2}
            displayType={'text'}
            isNumericString={true}
            fixedDecimalScale
            allowNegative={false}
          />
        ) : (
          ''
        ),
    },
    {
      title:
        'Número de agricultores que se espera que adopten la medida de adaptación',
      field: 'agriculturistNumber',
      align: 'center',
      grouping: false,
      type: 'numeric',
    },
  ]
  return (
    <div className="App">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={tableData}
            editable={{
              isDeleteHidden: (rowData) => rowData.LandAreaToImprove === null,

              onRowDelete: (oldData) =>
                new Promise((resolve, reject) => {
                  handleDelete(oldData)
                  setTimeout(() => resolve(), 500)
                }),
            }}
            actions={[
              // addOther
              //   ? {
              //       icon: () => (
              //         <Button
              //           variant="contained"
              //           color="success"
              //           style={
              //             !disabled
              //               ? { backgroundColor: '#27C27D', color: '#FFFFFF' }
              //               : {}
              //           }
              //           startIcon={<AddIcon style={{ color: 'white' }} />}
              //           onClick={() => {
              //             setOpen(true)
              //           }}
              //           disabled={disabled}
              //         >
              //           Agregar otra tecnología
              //         </Button>
              //       ),
              //       tooltip: !disabled
              //         ? 'Agregar'
              //         : 'Si desea agregar otra tecnología debe eliminar el registro',
              //       position: 'toolbar',
              //       // onClick: () => {
              //       //   setOpen(true)
              //       // },
              //     }
              //   : null,
              isEditable
                ? {
                    icon: () => <EditIcon style={{ color: '#0d53ad' }} />,
                    tooltip: 'Editar',
                    onClick: (event, rowData) => {
                      setOpenEdit(true)
                      setBody(rowData)
                    },
                    // hidden: rowData.LandAreaToImprove,
                  }
                : (rowData) =>
                    rowData.LandAreaToImprove !== null
                      ? {
                          icon: () => <EditIcon style={{ color: '#0d53ad' }} />,
                          tooltip: 'Editar',
                          onClick: (event, rowData) => {
                            setOpenEdit(true)
                            setBody(rowData)
                          },
                          // hidden: rowData.LandAreaToImprove,
                        }
                      : null,
            ]}
            onSelectionChange={(selectedRows) => console.log(selectedRows)}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: false,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'both',

              exportFileName: 'TableData',
              addRowPosition: 'first',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              toolbarButtonAlignment: 'left',
              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),
              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=""
            icons={{
              Add: () => <AddIcon style={{ color: 'green' }} />,
              Delete: () => <DeleteIcon style={{ color: 'red' }} />,
            }}
          />
        </Grid>
        <Modal52 open={open} setOpen={setOpen} getDataTable={getDataTable} />
        <Modal52Edit
          open={openEdit}
          setOpen={setOpenEdit}
          getDataTable={getDataTable}
          body={body}
          setBody={setBody}
        />
      </Grid>
    </div>
  )
}

export default React.memo(Table52)
